/**
 * @file scripts/pages/HttpError.jsx
 * @description
 * This is a generic Http error page
 */
import React, {Component} from 'react';
import ErrorMessages      from '../utils/error-messages';

class HttpError extends Component {
    constructor(props) {
        super(props);
        let httpStatus = decodeURIComponent(this.props.match.params.status) || 404;
        this.state = {
            status: httpStatus,
            message: ErrorMessages[httpStatus] || ErrorMessages.DEFAULT,
        }
    }

    render(){
        return (
            <div className="error-wrapper">
                <div className="fa fa-exclamation-triangle logo"></div>
                <div className="content">
                    <div className="heading-1">{this.state.status}</div>
                    <div className="heading-2">Sorry!</div>
                    <div className="message">{ this.state.message }</div>
                    {this.props.match.params.message && this.props.match.params.message !== 'undefined' &&
                        <div className="extra-message">
                            { decodeURIComponent(this.props.match.params.message) }
                        </div>                        
                    }
                    <div className="instruction">Return to the <a href="/">home</a> page.</div>
                </div>
            </div>
        );
    }
}

export default HttpError;
